/**
 * 本台帳の spaceCode（data_patch `SpaceForAll` が全 companyRegion に作る）。
 */
export const MAIN_SPACE_CODE = '00000000';
